
import React from 'react';
import { Select, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FeaturePreview } from '../FeaturePreview';
import { useTranslation } from 'react-i18next';

export function PaymentTypePreview() {
  const { t } = useTranslation();
  
  const previewContent = (
    <div className="space-y-2">
      <label className="text-sm font-medium">Payment Type</label>
      <Select disabled>
        <SelectTrigger>
          <SelectValue placeholder="Select payment type..." />
        </SelectTrigger>
      </Select>
    </div>
  );

  return (
    <FeaturePreview
      feature="payment_type_selection"
      title={t('paymentTypeSelection', 'Payment Type Selection')}
      description={t('paymentTypeDescription', 'Choose from multiple payment types and track payment schedules. Automate payment tracking and get reminders.')}
      previewContent={previewContent}
      compact={true}
      translationLinks={[
        { key: 'paymentTypeSelection', text: t('translateThis', 'Translate this') },
        { key: 'paymentTypeDescription', text: t('translateDescription', 'Translate description') }
      ]}
    />
  );
}
